/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import SequencePicker from '@/components/ProjectTaktPlan/SequencePicker.component.vue';

import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

import TSearchField from '@/components/Taktify/TSearchField.component.vue';

export const AddTWaggonMixin = {
  data: () => ({
    search: '',
    amount_of_waggons: 1,
    selected_sequence: {
      community: false,
      id: -1,
    },
    prefix: ''
  }),
  components: {
    StandardDataField,
    StandardFlexBox,
    SequencePicker,

    TrainHead,
    TrainTail,
    Waggon,
    Workpackage,
    TSearchField
  },
  computed: {
    ...mapGetters('Project', [
      'isInsertingTrain',
      'getSelectedSequence',
    ]),
    ...mapGetters('Community', [
      'getCommunitySequencesFiltered',
    ]),
    ...mapGetters('Sequence', [
      'getSequencesFiltered',
    ]),
    ...mapGetters('WorkBench', [
      'getWBObjectsFiltered',
      'getWBObjects',
      'getWBObject',
      'isWBObjEmpty'
    ]),
    ...mapGetters('WorkBenchLocal', [
      'getWBLObject',
    ]),
    workbench_variables() {
      return this.getWBLObject({
        path: [
          {workbench_variables: ''}
        ]
      });
    }
  },
  methods: {
    ...mapActions('Project', [
      'trainInsert',
      'trainDelete',
      'trainReplace',
      'setSelectedSequence'
    ]),
    ...mapActions('WorkBench', [
      'requestWBObject',
      'addLoadAll',
    ]),
    ...mapActions('WorkBenchLocal', [
      'updateWBLObject',
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarCreate'
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookup'
    ]),
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    selectSequence(sequence, is_community) {
      if (this.isInsertingTrain) {
        this.trainReplace({
          project_id: this.project_id,
          sequence: sequence.id,
          is_community: is_community,
          train_name: sequence.name,
          position: this.train_index + 1 + this.direction,
          train_index: this.train_index + 1 + this.direction,
        });
      } else {
        this.trainInsert({
          project_id: this.project_id,
          sequence: sequence.id,
          is_community: is_community,
          train_name: sequence.name,
          position: this.train_index + 1 + this.direction,
        });
      }
      // this.setSelectedSequence({
      //   community: is_community,
      //   id: sequence.id,
      // });
    },
    createTWaggon(token, tworkpackages = null){
      let self = this;
      let mod = 1;
      if (!self.reference.before) {
        mod = 2;
      }

      let u_object = {
        position: self.twaggon_index + parseInt(mod),
        token: token
      };

      if (tworkpackages !== null) {
        u_object.tworkpackages = tworkpackages;
      }

      let bulk_payload = {
        taktareas: [],
        twaggons: []
      };

      if (this.amount_of_waggons === '') {
        this.amount_of_waggons = 1;
      }

      for (var i = 0; i < this.amount_of_waggons; i++) {
        bulk_payload.taktareas.push(self.taktarea_id);
        bulk_payload.twaggons.push({
          position: self.twaggon_index + parseInt(mod) + i,
          token: token,
          tworkpackages: tworkpackages
        });
      }

      let payload = {
        bulk: {
          parents: {
            taktareas: bulk_payload.taktareas
          },
          targets: {
            twaggons: bulk_payload.twaggons
          },
        },
        url: [
          {projects: self.project_id},
          {trains: self.train_id},
          {taktareas: self.taktarea_id},
          {twaggons: ''},
          {createbulk: ''},
          {showWithEntitiesNormalized: ''}
        ],
      };

      self.requestSnackbarCreate({
        url: [
          {projects: self.project_id},
          {trains: self.train_id},
          {taktareas: self.taktarea_id},
          {twaggons: ''},
          {showWithEntitiesNormalized: ''}
        ],
        u_object: u_object,
        reference: self.reference,
        bulk_bulk: {amount: this.amount_of_waggons},
        selector:'reference'
      }).then(() => {
        self.createUObject(payload).then(() => {
          self.$router.push({ name: 'ProjectTaktPlan'});
            self.updateCalenderLookup(self.project_id).then(() => {
              // self.$router.push({
              //   name: 'TaktPlanAddWorkPackage',
              //   params: {
              //     project_id: self.project_id,
              //     train_id: self.train_id,
              //     taktarea_id: self.taktarea_id,
              //     twaggon_id: payload.resp_data.twaggons[0].id
              //   }
              // })
            });
          });
      });
    },
    translateWorkPackages(workpackages){
      let tworkpackages = [];
      for (var i = 0; i < workpackages.length; i++) {
        let twp = JSON.parse(JSON.stringify(this.getWBObject({ type: `${this.prefix}wagworkpackages`, id: workpackages[i]})));
        twp.tworksteps = this.getWBObjects({ type: `${this.prefix}wagworksteps`, ids: twp.wagworksteps});
        twp.tqualitysteps = this.getWBObjects({ type: `${this.prefix}wagqualitysteps`, ids: twp.wagqualitysteps});
        twp.tlogisticsteps = this.getWBObjects({ type: `${this.prefix}waglogisticsteps`, ids: twp.waglogisticsteps});
        twp.tdefectsteps = this.getWBObjects({ type: `${this.prefix}wagdefectsteps`, ids: twp.wagdefectsteps});
        twp.tdesignsteps = this.getWBObjects({ type: `${this.prefix}wagdesignsteps`, ids: twp.wagdesignsteps});
        twp.tmaterialsteps = this.getWBObjects({ type: `${this.prefix}wagmaterialsteps`, ids: twp.wagmaterialsteps});
        twp.tmachinesteps = this.getWBObjects({ type: `${this.prefix}wagmachinesteps`, ids: twp.wagmachinesteps});
        twp.thandoversteps = this.getWBObjects({ type: `${this.prefix}waghandoversteps`, ids: twp.waghandoversteps});
        // twp.tworkpackageimages = this.getWBObjects({ type: `${this.prefix}wagworkpackageimages`, ids: twp.wagworkpackageimages});
        twp.tworkpackageimages = [];

        delete twp.wagworksteps;
        delete twp.wagqualitysteps;
        delete twp.waglogisticsteps;
        delete twp.wagdefectsteps;
        delete twp.wagdesignsteps;
        delete twp.wagmaterialsteps;
        delete twp.wagmachinesteps;
        delete twp.waghandoversteps;
        delete twp.wagworkpackageimages;
        tworkpackages.push(twp);
      }
      return tworkpackages;
    },
    workbenchSearch(val){
      if (val && val !== '') {
        this.loadData(`&search=${val}`);
      }
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: val
          }
        });
    },
    switchWaggonType(type){
      this.prefix = type;

      var waggons = this.getWBObjectsFiltered({
        type: `${this.prefix}waggons`,
        search: {
          token: this.workbench_variables.search,
          name: this.workbench_variables.search,
          hashtag: this.workbench_variables.search,
        },
      })
      if (waggons.length == 0) {
        this.loadData(`&limit=8&offset=0`);
      }
    },
    loadData(url_suffix){
      return new Promise((resolve) => {
        this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            loading: true
          }
        });
        // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('sequences')) {
          this.requestWBObject({
            url: [
              {[`${this.prefix}waggons`]: ''},
              {showWithEntitiesNormalized: ''}
            ],
            url_suffix: url_suffix
          }).then(() => {
            this.updateWBLObject({
              path: [
                {workbench_variables: ''}
              ],
              update: {
                loading: false
              }
            });
            resolve();
          });
        // }
      });
    }
  }
};
